export const initHeaderFollow = (offset = 400) => {
  const header = document.querySelector('.header');
  if (!header) return;

  const toggleHeaderFollow = () => {
    header.classList.toggle('header--follow', window.scrollY > offset);
  };

  toggleHeaderFollow();
  window.addEventListener('scroll', toggleHeaderFollow, { passive: true });
};